import { put, select, takeLeading } from "redux-saga/effects";
import { HttpService, _ } from "src/services";

import { ContactUsTypes } from "../types";
import { ReduxAction, UserSession } from "../models";
import { Urls } from "src/constants";
import { toast } from "react-toastify";
import { ContactUsAction } from "../actions";
import { AxiosResponse } from "axios";

export function* ContactUsSaga() {
    yield takeLeading(ContactUsTypes.SUBMIT_CONTACT_US, submitContactUs);
    yield takeLeading(ContactUsTypes.GET_FEEDBACK_TYPES, getFeedTypes);
}

function* getFeedTypes() {
    try {

        const api = Urls.feedback.types();
        const response: AxiosResponse = yield HttpService.Fetch(api);
        yield put(ContactUsAction.setFeedbackTypes(response.data));
    }
    catch {
        yield put(ContactUsAction.setFeedbackTypes([]));
    }
}

function* submitContactUs(action: ReduxAction) {

    try {

        const { payload } = action;

        const user: UserSession = yield select((state: any) => state.UserState);

        const api = Urls.feedback.post();
        const model = payload;

        const headers = user.loggedIn ? {} : {
            "g-recaptcha-response": model.captcha
        };

        delete model.captcha;

        yield HttpService.Fetch(api, model, headers);

        toast.success(_("contactUsSent"));
        yield put(ContactUsAction.submitted(true));
    }
    catch {
        toast.error(_("contactUsFaild"));
        yield put(ContactUsAction.submitted(false));
    }

}